import {IForm} from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'corpId',
      type: 'select',
      label: '主体',
      placeholder: '请选择主体',
      filterable: true,
      clearable: true
    },
    {
      field: 'sid',
      type: 'input',
      label: '账号ID',
      placeholder: '请输入账号ID'
    },
    {
      field: 'usedBy',
      type: 'select',
      label: '使用人',
      filterable: true,
      clearable: true,
      placeholder: '请选择使用人'
    },
    {
      field: 'uname',
      type: 'input',
      label: '客户昵称',
      placeholder: '请输入客户昵称'
    },
    {
      field: 'isRepeat',
      type: 'select',
      label: '是否重复客户',
      clearable: true,
      placeholder: '请选择是否重复客户',
      options: [
        { title: '是', value: 1 },
        { title: '否', value: 0 }
      ]
    },
    {
      field: 'uid',
      type: 'input',
      label: '客户ID',
      placeholder: '请输入客户ID'
    },
    {
      field: 'unionid',
      type: 'input',
      label: 'UnionId',
      placeholder: '请输入客户unionId'
    },
    {
      field: 'thirdParty',
      type: 'select',
      label: '所属第三方',
      clearable: true,
      filterable: true,
      placeholder: '请选择所属第三方'
    },
    // {
    //   field: 'createdAtRange',
    //   type: 'datepicker',
    //   label: '加入时间',
    //   otherOptions: {
    //     startPlaceholder: '开始日期',
    //     endPlaceholder: '结束日期',
    //     type: 'daterange',
    //     'value-format': 'YYYY-MM-DD'
    //   }
    // }
  ]
}
